export interface Orders {
    orders: Order[];
    summary: Summary;
    pagination?: Pagination;
    available_countries?: CurrencySummary[];
  }

export interface Pagination {
    page: number;
    size: number;
    total_items: number;
    total_pages: number;
}

export enum PaymentProvider {
    CONTRA_ENTREGA = "contra_entrega",
    MERCADO_PAGO = "mercadopago",
    STRIPE = "stripe",
    CONFIO = "confio",
    SHOPIFY = "shopify",
}
  
export interface BenefitPurchase {
    label: string;
    name: string;
    price: number;
}

export interface Order {
    id: number;
    hash_id: string;
    priority: string;
    created_at: string;
    updated_at?: string | null;
    logistic_state: string;
    payment_method?: "cod" | "online" | string;
    payment_provider?: PaymentProvider;
    payment_state: string;
    total_value: number;
    total_value_usd?: number | null;
    total_value_with_discount: number;
    total_value_with_discount_usd?: number | null;
    total_value_paid?: number | null;
    total_value_paid_usd?: number | null;
    display_total_value?: number | null;
    display_total_value_paid?: number | null;
    display_total_value_with_discount?: number | null;
    display_currency_code?: string | null;
    usd_exchange_rate?: number | null;
    country_code?: string | null;
    currency_code?: string | null;
    customer_name: string;
    customer_las_name: string;
    customer_prefix_phone: string;
    customer_phone: string;
    customer_email: string;
    customer_address: string;
    total_units: number;
    channel: string;
    dropi_state?: DropiState;
    dropi_observed_status?: string | null;
    dropi_order_status?: string | null;
    dropi_url?: string;
    shopify_integration_state?: ShopifyState;
    shopify_retry_count?: number;
    shopify_next_retry_at?: string | null;
    shopify_last_error_code?: string | null;
    shopify_currency_mode?: "USD_CONVERSION" | "FUNNEL_CURRENCY" | string | null;
    shopify_original_currency?: string | null;
    shopify_original_total?: number | null;
    shopify_rate_date?: string | null;
    shopify_rate_used?: number | null;
    shopify_currency_sent?: string | null;
    shopify_total_sent?: number | null;
    dropi_integration_error?: string;
    shopify_integration_error?: string;
    benefit_purchases?: BenefitPurchase[];
}

export enum DropiState {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    PENDING_SYNC = "PENDING_SYNC",
    WAITING_PAYMENT = "WAITING_PAYMENT",
}

export enum ShopifyState {
    PENDING = "PENDING",
    PENDING_RATE = "PENDING_RATE",
    RETRYING = "RETRYING",
    SUCCESS = "SUCCESS",
    ERROR_RETRYABLE = "ERROR_RETRYABLE",
    ERROR_FINAL = "ERROR_FINAL",
    ERROR = "ERROR",
    PENDING_SYNC = "PENDING_SYNC",
}
  
export interface Summary {
    total_buyers: number;
    total_units: number | string;
    total_value: number | string;
    total_value_with_discount: number | string;
    currency_breakdown?: CurrencySummary[];
  }

export interface CurrencySummary {
    country_code?: string | null;
    currency_code?: string | null;
    total_value: number | string;
    total_value_paid?: number | string | null;
    total_value_with_discount: number | string;
}
